import { SignIn } from "@clerk/clerk-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@clerk/clerk-react";
import { useEffect } from "react";
import s from "./styles.module.scss";
import PageHeader from "../../components/page-header";
import InAppBrowserDetector from "../../components/in-app-browser-detector";
import React from "react";

const ClerkSignIn = () => {
  const navigate = useNavigate();
  const { isSignedIn, isLoaded } = useAuth();

  // Handle redirect after successful sign-in
  useEffect(() => {
    if (isLoaded && isSignedIn) {
      console.log("User is signed in, redirecting to /upload");
      navigate("/upload", { replace: true });
    }
  }, [isLoaded, isSignedIn, navigate]);

  return (
    <InAppBrowserDetector>
      <div className={s.authContainer}>
        <PageHeader title="Welcome to Ocean" />

        <SignIn
          appearance={{
            elements: {
              socialButtons: s.socialButtons,
              logoBox: s.logoBox,
              headerTitle: s.headerTitle,
              card: s.card,
              cardBox: s.cardBox,
              socialButtonsBlockButton: s.socialButtonsBlockButton,
              main: s.main,
              socialButtonsBlockButtonText: s.socialButtonsBlockButtonText,
              formFieldLabel: s.formFieldLabel,
              formFieldInput: s.formFieldInput,
              formButtonPrimary: s.formButtonPrimary,
              buttonArrowIcon: s.buttonArrowIcon,
              footerAction: s.footerAction,
              footer: s.footer,
            },
            layout: {
              socialButtonsPlacement: "top",
              socialButtonsVariant: "blockButton",
            },
          }}
          signUpUrl="/sign-up"
          afterSignInUrl="/upload"
          forceRedirectUrl="/upload"
          fallbackRedirectUrl="/upload"
          routing="virtual"
          redirectUrl="/upload"
        />
      </div>
    </InAppBrowserDetector>
  );
};

export default ClerkSignIn;
